import React from 'react';
import { MdAdd, MdEdit } from 'react-icons/md';
import DefaultButton from '../../ReusableComponents/DefaultButton';
import StatusBadge from '../../ReusableComponents/StatusBadge';
import FormattedText from './FormattedText';

export default function FormDocuments({ documents, allowed, onAdd, onEdit }) {
  return (
      <section className="portal-form-documents" aria-label="Arquivos do formulário">
        <div className="portal-admin-row">
          <div><h3>Arquivos e documentos</h3><p>Estes arquivos são cadastrados em Documentos e enviados na etapa de documentação da inscrição.</p></div>
          <DefaultButton text="Adicionar arquivo" bg="success" icon={<MdAdd />} disabled={!allowed} onClick={() => onAdd()} />
        </div>
        {!documents.length && <p className="text-muted">Nenhum documento cadastrado.</p>}
        {documents.map(item => (
          <div className="portal-admin-item" key={item.id}>
            <div><strong><FormattedText>{item.title}</FormattedText></strong><small className="form-text">Arquivo · {(item.allowed_types || ['pdf', 'jpg', 'jpeg', 'png']).join(', ').toUpperCase()} · até {Number((item.max_kb / 1024).toFixed(2))} MB</small></div>
            <div className="portal-admin-actions actions-group">
              <StatusBadge variant={item.required ? 'info' : 'secondary'}>{item.required ? 'Obrigatório' : 'Opcional'}</StatusBadge>
              <DefaultButton text="Editar documento" bg="info" icon={<MdEdit />} disabled={!allowed} onClick={() => onEdit(item)} />
            </div>
          </div>
        ))}
      </section>
  );
}
